import { gql } from '@apollo/client';

export const ADD_ACTIVITIES_TO_INTERVENTION = gql`
  mutation addActivitiesToIntervention($input: AddActivitiesToInterventionInput!) {
    activities: addActivitiesToIntervention(input: $input) {
      id
      name
    }
  }
`;
